import React, { useEffect } from 'react';
import { strings } from '../localisation';
import styled from 'styled-components';
import { Text } from '@starryui10/typography/Text';
import { Stack } from '@starryui10/layouts/Stack';
import { useSentry } from '@starryui10/hooks/useSentry';
import { scheme } from '@starryui10/theme/scheme';
import { Json } from '@starryui10/Components/Json';

declare let SEND_TO_SENTRY: boolean;

interface IErrorDisplayProps {
    error: Error | string;
}

export const ErrorDisplay = ({ error }: IErrorDisplayProps) => {
    const { captureException } = useSentry();

    useEffect(() => {
        if (SEND_TO_SENTRY && error) {
            captureException(error);
        }
    }, [error]);

    return (
        <Stack pad="large">
            <WrapperDiv>
                <Stack pad={'small'}>{error ? <Json json={error} /> : <Text role="alert">{strings.Message_UnknownError}</Text>}</Stack>
            </WrapperDiv>
        </Stack>
    );
};

const WrapperDiv = styled.div`
    ${(_) => ({ ...scheme.Red.Lighter })}
    border-radius: 4px;
`;
